.marketMoversCard {
  width: 100%;
  max-width: 100%;
  background-color: var(--cxy-color-container-light);
  border-radius: var(--cxy-spacing-2);
  overflow: hidden;
  color: white;
  font-family: var(--font-family-base);
  box-sizing: border-box;
  --left-column-size: 4;
  --right-column-size: 7;
  --columns-gap: 10px;
  --column-grid-template-columns: minmax(42px, 1fr) minmax(42px, 1fr) 85px minmax(42px, 1fr) minmax(42px, 1fr)
    min(100px);
}
.marketMoversCard .headerRow {
  background-color: var(--cxy-color-container-subtle);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.marketMoversCard .eventTitle {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
  flex: 0 0 auto;
  flex: var(--left-column-size);
}
.marketMoversCard .headerColumns {
  display: grid;
  grid-template-columns: var(--column-grid-template-columns);
  column-gap: var(--columns-gap);
  flex: var(--right-column-size);
  justify-content: space-between;
}
.marketMoversCard .headerColumn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--cxy-spacing-1);
}
.marketMoversCard .headerColumn:nth-child(3) {
  max-width: 85px;
  text-align: center;
}
.marketMoversCard .headerColumn:nth-child(6) {
  min-width: 100px;
  text-align: center;
}
.marketMoversCard .columnHeading {
  font-size: var(--cxy-fontSize-xs);
  color: var(--cxy-color-white);
  font-weight: var(--cxy-fontWeight-semiBold);
  white-space: normal;
}
.marketMoversCard .contentRow {
  display: flex;
  align-items: stretch;
  gap: 10px;
  padding: 0 var(--cxy-spacing-4);
}
.marketMoversCard .horseInfoColumn {
  flex: var(--left-column-size);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.marketMoversCard .horseInfoColumn .horseInfoLocked {
  display: flex;
  font-weight: var(--cxy-fontWeight-semiBold);
  align-items: center;
  color: var(--cxy-color-white);
  gap: var(--cxy-spacing-1);
  font-size: var(--cxy-fontSize-s);
}
.marketMoversCard .horseInfoColumn .horseInfoLocked .ghostButton {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: var(--cxy-color-brand);
}
.marketMoversCard .dataColumns {
  display: grid;
  grid-template-columns: var(--column-grid-template-columns);
  column-gap: var(--columns-gap);
  flex: var(--right-column-size);
  justify-content: space-between;
  align-items: center;
}
.marketMoversCard .dataColumn {
  text-align: left;
}
.marketMoversCard .dataColumn:nth-child(3) {
  max-width: 85px;
}
.marketMoversCard .dataColumn:nth-child(6) {
  min-width: 100px;
}
.marketMoversCard .horseInfo {
  display: flex;
  align-items: center;
  padding: var(--cxy-spacing-4) 0;
  gap: var(--cxy-spacing-4);
}
.marketMoversCard .horseAvatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--cxy-color-white);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: contain;
}
.marketMoversCard .horseAvatar .avatarImage {
  width: 80%;
  height: 80%;
}
.marketMoversCard .horseDetails {
  display: flex;
  flex-direction: column;
}
.marketMoversCard .horseDetails .horseName {
  color: var(--cxy-color-white);
  font-size: var(--cxy-fontSize-text-m);
  font-weight: var(--cxy-fontWeight-bold);
  margin: 0;
}
.marketMoversCard .horseDetails .jockeyName {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-white);
}
.marketMoversCard .oddsValue {
  font-size: var(--cxy-fontSize-text-m);
  font-weight: var(--cxy-fontWeight-semiBold);
}
.marketMoversCard .oddsValue .padlock {
  margin: 0 auto;
}
.marketMoversCard .swingValue {
  font-size: var(--cxy-fontSize-text-m);
  font-weight: var(--cxy-fontWeight-semiBold);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-1);
}
.marketMoversCard .swingValue.positive {
  color: #00e889;
}
.marketMoversCard .swingValue.negative {
  color: #ff8e9c;
}
.marketMoversCard .mobileSwingCarouselItem {
  position: relative;
  padding: var(--cxy-spacing-3);
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: var(--cxy-spacing-2);
  box-sizing: border-box;
  background-color: var(--cxy-color-container-contrast);
}
.marketMoversCard .desktopSwingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--cxy-color-container-contrast);
  min-height: 70px;
  box-sizing: border-box;
  width: 85px;
  min-width: 85px;
  max-width: 85px;
  position: relative;
  padding-bottom: var(--cxy-spacing-2);
}
.marketMoversCard .swingHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-1);
  width: 100%;
}
.marketMoversCard .swingLabel {
  font-size: var(--cxy-fontSize-xs);
  color: var(--cxy-color-white);
  font-weight: var(--cxy-fontWeight-semiBold);
}
.marketMoversCard .swingInfoIcon {
  color: var(--cxy-color-white);
  font-size: var(--cxy-fontSize-xs);
  opacity: 0.7;
}
.marketMoversCard .swingValueContainer {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-1);
  margin: var(--cxy-spacing-1) 0;
  margin-top: var(--cxy-spacing-3);
}
.marketMoversCard .swingTriangle {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
}
.marketMoversCard .swingTriangle.positive {
  color: #00e889;
}
.marketMoversCard .swingTriangle.negative {
  color: #ff8e9c;
}
.marketMoversCard .swingPercentage {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
  white-space: nowrap;
}
.marketMoversCard .swingPercentage.positive {
  color: #00e889;
}
.marketMoversCard .swingPercentage.negative {
  color: #ff8e9c;
}
.marketMoversCard .swingProgressBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}
.marketMoversCard .swingProgressFill {
  height: 100%;
  width: var(--progress-width);
  transition: width 0.3s ease;
}
.marketMoversCard .swingProgressFill.positive {
  background-color: #00e889;
}
.marketMoversCard .swingProgressFill.negative {
  background-color: #ff8e9c;
}
.marketMoversCard .mobileBetButtonContainer {
  padding: var(--cxy-spacing-4);
}
.marketMoversCard .bestOddsContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-2);
}
.marketMoversCard .statsAndDescription {
  display: flex;
  gap: 10px;
  background-color: var(--cxy-color-blue-550);
}
.marketMoversCard .horseStatsRow {
  flex: var(--left-column-size);
  padding: var(--cxy-spacing-4);
  padding-right: 0;
}
.marketMoversCard .horseStatsRow .statsColumns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
}
.marketMoversCard .statItem {
  display: flex;
  gap: var(--cxy-spacing-1);
  color: var(--cxy-color-white);
}
.marketMoversCard .statItem .statLabel {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
}
.marketMoversCard .statItem .statValue {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
}
.marketMoversCard .description {
  padding: var(--cxy-spacing-4);
  padding-left: 0;
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-white);
  line-height: 1.5;
  flex: var(--right-column-size);
}
.marketMoversCard .eventHeader {
  background-color: var(--cxy-color-container-subtle);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-4);
}
.marketMoversCard .eventHeader .eventInfo {
  font-size: var(--cxy-fontSize-s);
  font-weight: 500;
}
.marketMoversCard .horseInfoSection {
  padding: var(--cxy-spacing-4) var(--cxy-spacing-4) 0;
  max-width: 100%;
}
.marketMoversCard .horseInfoLocked {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-1);
  color: var(--cxy-color-white);
  font-size: var(--cxy-fontSize-s);
}
.marketMoversCard .horseInfoLocked .unlockContentLabel {
  padding-bottom: var(--cxy-spacing-0);
}
.marketMoversCard .ghostButton {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: var(--cxy-color-brand);
}
.marketMoversCard .mobileCarouselContainer {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  padding: var(--cxy-spacing-4) 0;
  margin: 0;
  box-sizing: border-box;
}
.marketMoversCard .carouselContent {
  padding-inline-start: var(--cxy-spacing-4);
}
.marketMoversCard .carouselItemSmall {
  max-width: 100px;
}
.marketMoversCard .carouselItemMedium {
  max-width: 120px;
}
.marketMoversCard .carouselControl:disabled {
  display: none;
}
.marketMoversCard .mobileCarouselItem {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  gap: var(--cxy-spacing-3);
  height: 100%;
  padding-top: var(--cxy-spacing-0);
  padding-bottom: var(--cxy-spacing-4);
}
.marketMoversCard .mobileCarouselItemLabel {
  font-size: var(--cxy-fontSize-xs);
  color: var(--cxy-color-white);
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-spacing-4);
}
.marketMoversCard .mobileCarouselItemValue {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-white);
  line-height: var(--cxy-spacing-4);
}
.marketMoversCard .horseStatsSection {
  background-color: var(--cxy-color-blue-550);
  padding: var(--cxy-spacing-2) var(--cxy-spacing-4);
}
.marketMoversCard .horseStatsGrid {
  display: grid;
  gap: 0;
  grid-template-columns: 1fr 1fr;
}
.marketMoversCard .lockedAnalysisCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.marketMoversCard .lockedAnalysisDesktop {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--cxy-spacing-6) 0;
  width: 100%;
}
.marketMoversCard .padlock {
  color: var(--cxy-color-brand);
  stroke-width: 2px;
}
/* The shared `Info` icon paints with `currentColor`; this card sits on a dark surface. */
.swingInfoIcon {
  color: rgb(255 255 255 / 60%);
}
.marketMoversCard.isLocked .headerColumn {
  text-align: center;
}
.marketMoversCard.isLocked .mobileCarouselItem .mobileCarouselItemLabel {
  text-align: center;
}
.marketMoversCard.isLocked .mobileCarouselItem .mobileCarouselItemValue {
  margin: 0 auto;
}

@media (max-width: 1024px) {
  .marketMoversCard .description {
    background: var(--cxy-color-blue-550);
    padding: var(--cxy-spacing-2) var(--cxy-spacing-4);
  }
}
@media (max-width: 768px) {
  .marketMoversCard .headerRow {
    flex-direction: column;
    align-items: flex-start;
  }
  .marketMoversCard .eventTitle {
    width: 100%;
    margin-bottom: var(--cxy-spacing-3);
  }
  .marketMoversCard .headerColumns {
    display: none;
  }
  .marketMoversCard .contentRow {
    flex-direction: column;
    padding: var(--cxy-spacing-4) var(--cxy-spacing-4) var(--cxy-spacing-2);
  }
  .marketMoversCard .horseInfoColumn {
    width: 100%;
    margin-right: 0;
    margin-bottom: var(--cxy-spacing-4);
  }
  .marketMoversCard .horseInfo {
    padding: 0;
  }
  .marketMoversCard .dataColumns {
    display: none;
  }
  .marketMoversCard .statsAndDescription {
    flex-direction: column;
  }
  .marketMoversCard .horseStatsRow {
    width: 100%;
    padding: 0;
    display: none;
  }
  .marketMoversCard .description {
    border-left: none;
    padding: var(--cxy-spacing-2) var(--cxy-spacing-4);
    background: var(--cxy-color-blue-550);
  }
  .marketMoversCard .swingValue {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
